<template>
  <li
    class="t-navigation-item"
  >
    <slot v-if="dummy"></slot>
    <component
      v-else
      :is="tag"
      v-bind="$attrs"
      class="t-navigation-item__link"
      :class="[{
        't-navigation-item__link--active': active,
      }]"
    >
      <span
        class="t-navigation-item__icon"
      >
        <t-icon
          :icon="icon"
          fixed-width
        ></t-icon>
        <slot v-if="$slots.indicator" name="indicator"></slot>
      </span>
      <span
        v-if="$slots.default"
        class="t-navigation-item__text"
      >
        <slot></slot>
      </span>
    </component>
  </li>
</template>

<script>
import { navigationTags } from '../../enums';
import { TIcon } from '../TIcon';

export default {
  name: 't-navigation-item',

  props: {
    icon: [String, Array],
    active: Boolean,
    dummy: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: String,
      default: navigationTags.A,
      validator: (value) => Object.values(navigationTags).includes(value),
    },
  },

  components: {
    TIcon,
  },
};
</script>
